"use client";

import {
  ActivityIcon,
  SettingsIcon,
  UsersIcon,
  ListIcon,
  AwardIcon,
  ReceiptTextIcon,
  BanIcon,
  FileTextIcon,
  Trash2Icon,
  XCircle,
  Repeat,
} from "lucide-react";
import { TabsCard } from "@/components/backoffice/tabs-card";
import { AdministrationConfigurableLists } from "@/components/backoffice/system/administration-configurable-lists";
import { AdministrationActivity } from "@/components/backoffice/system/administration-activity";
import { AdministrationAak } from "@/components/backoffice/system/aak";
import { AdministrationColorRules } from "@/components/backoffice/system/color-rules/administration-color-rules";
import { AdministrationFacturationRules } from "@/components/backoffice/system/facturation-rules";
import { AdministrationFacturationExclusionRules } from "@/components/backoffice/system/facturation-exclusion-rules";
import { AdministrationDocumentSignataires } from "@/components/backoffice/system/document-signataires";
import { AdministrationDraftPurge } from "@/components/backoffice/system/administration-draft-purge";
import { ImmatriculationCodeRejetRecyclAutoItemsListCard } from "./Immat-code-rejet-recycl-auto";
import ImmatriculationFlow from "./immatriculation-flow";

const tabs = [
  {
    name: "Natures de vente",
    value: "aak",
    icon: ListIcon,
    content: <AdministrationAak />,
  },
  {
    name: "Listes",
    value: "configurable-lists",
    icon: SettingsIcon,
    content: <AdministrationConfigurableLists />,
  },
  {
    name: "Gestion des Utilisateurs",
    value: "users",
    icon: UsersIcon,
    content: "WIP",
  },
  {
    name: "Couleur / Nuance",
    value: "color-rules",
    icon: AwardIcon,
    content: <AdministrationColorRules />,
  },
  {
    name: "Facturation opérations",
    value: "facturation-rules",
    icon: ReceiptTextIcon,
    content: <AdministrationFacturationRules />,
  },
  {
    name: "Exclusions facturation",
    value: "facturation-exclusion-rules",
    icon: BanIcon,
    content: <AdministrationFacturationExclusionRules />,
  },
  {
    name: "Signataires documents",
    value: "document-signataires",
    icon: FileTextIcon,
    content: <AdministrationDocumentSignataires />,
  },
  {
    name: "Purge Brouillons",
    value: "draft-purge",
    icon: Trash2Icon,
    content: <AdministrationDraftPurge />,
  },
  {
    name: "SIV - Codes rejets",
    value: "siv-codes-rejets",
    icon: XCircle,
    content: <ImmatriculationCodeRejetRecyclAutoItemsListCard />,
  },
  {
    name: "SIV - flux immatriculation",
    value: "siv-coupure",
    icon: Repeat,
    content: <ImmatriculationFlow />,
  },
  {
    name: "Logs d'activité",
    value: "logs",
    icon: ActivityIcon,
    content: <AdministrationActivity />,
  },
];

function AdministrationTabsCard() {
  return <TabsCard tabs={tabs} />;
}

export { AdministrationTabsCard };
